<template>
  <div id="app">
    <el-menu
      v-if="isLogin"
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
          <el-menu-item index="/">统计</el-menu-item>
      <el-menu-item index="/position">职位</el-menu-item>
      <el-menu-item index="/txList">提现审核</el-menu-item>
      <el-menu-item index="/companyAudit">企业认证</el-menu-item>
      <el-menu-item index="/authApply">会员认证</el-menu-item>
      <el-menu-item index="/zjList">奖品列表</el-menu-item>
      <el-menu-item index="/userList">用户列表</el-menu-item>
      <el-menu-item index="/dhkList">电话快列表</el-menu-item>
      <el-menu-item index="/rankClassList">排行榜</el-menu-item>
      <el-menu-item index="/paUser">PA端新用户</el-menu-item>
      <el-menu-item index="/banner">banner管理</el-menu-item>
      
    </el-menu>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      activeIndex1: "/",
      activeIndex2: "/position",
      activeIndex3: "/txList",
      activeIndex4: "/companyAudit",
      activeIndex5: "/authApply",
      activeIndex6: "/zjList",
      activeIndex7: "/userList",
      activeIndex8: "/dhkList",
      activeIndex9: "/rankClassList",
      isLogin: true
    };
  },

  watch: {
    $route(to, from) {
      if (
        localStorage.getItem("token") === "" ||
        localStorage.getItem("token") === undefined ||
        localStorage.getItem("token") === null
      ) {
        this.isLogin = false
        this.$router.push({
          path: "/login"
        });
      } else {
          this.isLogin = true
      }
    }
  },

  created() {
    if (
      localStorage.getItem("token") === "" ||
      localStorage.getItem("token") === undefined ||
      localStorage.getItem("token") === null
    ) {
      this.isLogin = false
      this.$router.push({
        path: "/login"
      });
    } else {
      this.isLogin = true
      this.activeIndex = "/" + this.$route.path.split("/")[1];
    }
  },

  methods: {
    handleSelect(key, keyPath) {
      // eslint-disable-next-line
      console.log(key + " " + keyPath);
      this.$router.push({ path: keyPath[0] });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
#app {
  background-color: #e4e2e5;
  min-height: 100vh;
  min-width: 100vw;
  padding-bottom: 5vh;
}
.selectTypeBox {
  width: max-content;
  margin: 20px auto;
}
</style>
